import { FeatureModule } from '@store/features/types';
import appointmentsReducer from './slice';
import { appointmentsApiSlice } from './api';
import storage from 'redux-persist/lib/storage'; // localStorage

/**
 * Appointments feature module definition
 * Configures persistence for user preferences and integrates with RTK Query
 */
export const appointmentsFeature: FeatureModule = {
  // Basic feature identification
  id: 'appointments',
  name: 'Appointments',

  // Optional feature dependencies
  dependencies: [], // No dependencies for this feature

  // Feature reducers
  reducers: {
    appointments: appointmentsReducer,
  },

  // Include API middleware for RTK Query functionality
  middleware: [appointmentsApiSlice.middleware],

  // Configure persistence for user preferences and view state
  persistence: {
    enabled: true,
    key: 'appointments',
    storage: storage, // Use localStorage for persistence across browser restarts

    // Only persist user preferences, not transient data
    whitelist: [
      'viewMode', // Calendar view mode (day/week/month/list)
      'displayMode', // Display preference (calendar/list)
      'currentDate', // Currently selected date
      'calendarGranularity', // Calendar time slot and step settings
      'orgScheduleFilters', // Org schedule filter selections (provider/patient)
    ],

    // Don't persist transient or computed state
    blacklist: [
      'appointments', // Appointment data (loaded from API)
      'nextAppointment', // Next appointment (loaded from API)
      'isTutorialMode', // Tutorial state (should not persist)
      'mockAppointments', // Mock data
    ],

    version: 1,
    mergeStrategy: 'merge',
  },

  // Configure cross-tab synchronization for real-time updates
  sync: {
    enabled: false,
  },

  // Feature lifecycle hooks
  setup: store => {
    console.log(`${appointmentsFeature.name} feature initialized`);

    // Initialize default state from localStorage if available
    const state = store.getState();
    if (state.appointments) {
      // Feature is loaded and ready
      console.log('Appointments feature state loaded from persistence');
    }
  },

  cleanup: store => {
    console.log(`${appointmentsFeature.name} feature cleaned up`);

    // Cleanup any subscriptions or timers if needed
    // The RTK Query cache will be cleaned up automatically
  },
};

/**
 * Initialize feature - call this when registering the feature
 */
export function initializeAppointmentsFeature() {
  return {
    api: appointmentsApiSlice,
    feature: appointmentsFeature,
  };
}
